<template>
  <section class="px-16 mt-8">
    <loading-flux :value="loadingActions"></loading-flux>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <section class="d-flex flex-column flex-sm-row justify-content-between">
          <h2 class="my-3">Proyectos de Preventa</h2>
        </section>
      </v-col>
      <v-col cols="12" lg="12" md="12" sm="12" class="pt-0 pb-3">
        <v-btn
          v-if="
            currentUserIsSuperAdmin ||
              activeBusinessUnits.length ||
              verifyUserBelongsToCgestionCostCenter
          "
          @click="openModalUpdateOrCreatePresale(null)"
          :disabled="loading"
          color="primary"
          :dark="false"
          small
          class="text-white mt-4"
        >
          <i class="mdi mdi-plus me-1"></i>
          Crear Proyecto de Preventa
        </v-btn>
        <v-btn
          class="mt-4 mx-4"
          color="success text-white"
          small
          :disabled="!presales.items.length"
          @click="downloadExcelReportPresale"
        >
          <!-- icon excel -->
          <v-icon small class="mr-1"> mdi-file-excel </v-icon>
          Exportar
        </v-btn>
      </v-col>
      <v-col cols="12" lg="3" md="3" sm="12" class="mb-2">
        <v-text-field
          label="Búsqueda"
          @input="($event) => getPresalesData()"
          v-model="filters.filter"
          clearable
          class="mt-3"
          placeholder="Búsqueda"
          append-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
      <v-col cols="12" lg="3" md="3" sm="12" class="mb-2">
        <v-autocomplete
          v-model="filters.items"
          class="mt-3"
          @change="($event) => getPresalesData()"
          :items="[5, 10, 15, 20, 25]"
          label="Items por página"
        >
        </v-autocomplete>
      </v-col>
      <v-col
        cols="12"
        lg="3"
        md="3"
        sm="12"
        class="mb-2"
        v-if="showAllPresales"
      >
        <v-autocomplete
          class="mt-3"
          placeholder="Filtrar por Unidad de Negocio"
          v-model="filters.business_unit"
          :items="activeBusinessUnits"
          @change="($event) => getPresalesData()"
          item-text="name"
          item-value="code"
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" lg="3" md="3" sm="12" class="mb-2">
        <v-autocomplete
          class="mt-3"
          placeholder="Filtrar por Estatus"
          v-model="filters.approved_status"
          :items="LIST_STATUS_PRESALE"
          @change="($event) => getPresalesData()"
          item-text="name"
          item-value="name"
          clearable
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="12" sm="12" class="mb-2">
        <v-data-table
          :page.sync="filters.page"
          :headers="wrappedTableHeaders"
          :items="presales.items ? presales.items : []"
          item-key="code"
          :items-per-page="filters.items"
          class="elevation-1"
          mobile-breakpoint="993"
          hide-default-footer
          :loading="loading"
          no-data-text="No hay Datos para Mostrar"
          loading-text="Cargando Preventas... Espere Por favor"
        >
          <template v-slot:item.code="{ item }">
            <div class="d-flex align-items-center justify-content-center">
              {{ item.code }}
            </div>
          </template>
          <template v-slot:item.name="{ item }">
            <div class="d-flex align-items-center">
              <div
                :class="{
                  'link-text': userAuthIsInListUserRestrictedDocuments,
                }"
                class="text-left"
                @click="
                  userAuthIsInListUserRestrictedDocuments
                    ? showPresaleDocuments(item)
                    : null
                "
              >
                {{ item.name }}
              </div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-if="item.project"
                    class="mx-2"
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-check-circle
                  </v-icon>
                </template>
                <span v-if="item.project"
                  >Proyecto asociado: {{ item.project.code }}</span
                >
              </v-tooltip>
            </div>
          </template>
          <template v-slot:item.business_unit="{ item }">
            <v-chip pill color="primary" class="text-white">{{
              item.business_unit.name
            }}</v-chip>
          </template>
          <template v-slot:item.approved_status="{ item }">
            <v-chip
              v-if="item.approved_status"
              pill
              :color="getColorPresale(item.approved_status)"
              class="text-white"
              >{{ item.approved_status }}</v-chip
            >
            <span v-else> N/A </span>
          </template>
          <template v-slot:item.created_at="{ item }">
            <span v-if="item.created_at != null">{{
              formatDateToHuman(item.created_at)
            }}</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-menu :close-on-content-click="true">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" class="blue darken-3" fab x-small outlined>
                  <v-icon color="white"> mdi-dots-vertical </v-icon>
                </v-btn>
              </template>
              <v-list rounded>
                <v-list-item
                  class="mb-0 px-2"
                  v-if="
                    item.business_unit.code == BUSINESS_UNIT_RESIDENTIAL_CODE &&
                      item.approved_status &&
                      item.approved_status == STATUS_PRESALE_REVIEW_PENDING &&
                      (currentUserIsSuperAdmin ||
                        verifyUserBelongsToCgestionCostCenter)
                  "
                >
                  <v-list-item-title
                    @click="changePresaleStatus(item, STATUS_PRESALE_APPROVED)"
                    x-small
                    class="pointer mx-0 px-0"
                  >
                    <v-icon color="success" class="mr-2">
                      mdi-check-circle
                    </v-icon>
                    <span>Aprobar Preventa y Crear Proyecto en SAP</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="mb-0 px-2"
                  v-if="
                    item.business_unit.code == BUSINESS_UNIT_RESIDENTIAL_CODE &&
                      item.approved_status &&
                      item.approved_status == STATUS_PRESALE_REVIEW_PENDING &&
                      (currentUserIsSuperAdmin ||
                        verifyUserBelongsToCgestionCostCenter)
                  "
                >
                  <v-list-item-title
                    @click="
                      changePresaleStatus(item, STATUS_PRESALE_REVIEW_USER)
                    "
                    x-small
                    class="pointer mx-0 px-0"
                  >
                    <v-icon color="warning" class="mr-2"> mdi-alert </v-icon>
                    <span>Enviar a Revisión por Usuario</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="mb-0 px-2"
                  v-if="
                    item.business_unit.code == BUSINESS_UNIT_RESIDENTIAL_CODE &&
                      item.approved_status &&
                      (item.approved_status == STATUS_PRESALE_REVIEW_USER || item.approved_status == STATUS_PRESALE_SIGNED) &&
                      (currentUserIsSuperAdmin ||
                        verifyUserBelongsToCgestionCostCenter ||
                        verifyUserBelongsToComCostCenter ||
                        verifyCurrentUserPermissionToManageAutomationPresales(
                          item,
                        ))
                  "
                >
                  <v-list-item-title
                    @click="
                      changePresaleStatus(item, STATUS_PRESALE_REVIEW_PENDING)
                    "
                    x-small
                    class="pointer mx-0 px-0"
                  >
                    <v-icon color="success" class="mr-2">
                      mdi-check-circle
                    </v-icon>
                    <span>Enviar a Pendiente de Revisión</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="mb-0 px-2"
                  v-if="
                    item.business_unit.code == BUSINESS_UNIT_RESIDENTIAL_CODE &&
                      item.approved_status &&
                      (currentUserIsSuperAdmin ||
                        verifyUserBelongsToCgestionCostCenter)
                  "
                >
                  <v-list-item-title
                    @click="openModalClientAndProjectInfo(item)"
                    x-small
                    class="pointer mx-0 px-0"
                  >
                    <v-icon color="primary" class="mr-2"> mdi-account </v-icon>
                    <span>Ver Info del Cliente y Proyecto SAP</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  class="mb-0 px-2"
                  v-if="userAuthIsInListUserRestrictedDocuments"
                >
                  <v-list-item-title
                    @click="showPresaleDocuments(item)"
                    x-small
                    class="pointer mx-0 px-0"
                  >
                    <v-icon color="success" class="mr-2"> mdi-folder </v-icon>
                    <span>Ver Documentos</span>
                  </v-list-item-title>
                </v-list-item>
                <!-- <v-list-item
                  class="mb-0 px-2"
                  v-if="
                    verifyUserBelongsToCgestionCostCenter ||
                      currentUserIsSuperAdmin
                  "
                >
                  <v-list-item-title
                    @click="openModalLinkPresaleToProject(item)"
                    x-small
                    class="pointer mx-0 px-0"
                  >
                    <v-icon color="primary" class="mr-2"> mdi-link </v-icon>
                    <span>Enlazar a Proyecto</span>
                  </v-list-item-title>
                </v-list-item> -->
                <v-list-item
                  class="mb-0 px-2"
                  v-if="
                    verifyUserBelongsToCgestionCostCenter ||
                      currentUserIsSuperAdmin
                  "
                >
                  <v-list-item-title
                    @click="openModalUpdateOrCreatePresale(item)"
                    x-small
                    class="pointer mx-0 px-0"
                  >
                    <v-icon color="warning" class="mr-2"> mdi-pencil </v-icon>
                    <span>Editar</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item class="mb-0 px-2" v-if="currentUserIsSuperAdmin">
                  <v-list-item-title
                    @click="deletePresale(item)"
                    x-small
                    class="pointer mx-0 px-0"
                  >
                    <v-icon color="red darken-2" class="mr-2">
                      mdi-delete
                    </v-icon>
                    <span>Eliminar</span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination
            v-model="filters.page"
            :length="presales ? presales.total_pages : 1"
            :total-visible="8"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
    <modal-update-or-create-presale
      ref="modalUpdateOrCreatePresale"
      :currentPresale="currentPresale"
      :modalAction="dialogCreatePresale"
      :closeModalCreateOrUpdatePresale="closeModalCreateOrUpdatePresale"
      @presaleCreatedOrUpdated="getPresalesData(1)"
    >
    </modal-update-or-create-presale>
    <modal-link-presale-to-project
      :modalAction="dialogLinkPresaleToProject"
      :closeModalLinkPresaleToProject="closeModalLinkPresaleToProject"
      :currentPresale="currentPresale"
      @presaleLinkedToProject="getPresalesData(1)"
    >
    </modal-link-presale-to-project>
    <modal-create-project-from-presale
      ref="modalCreateProjectFromPresale"
      :modalAction="dialogInfoClientAndProject"
      :closeModalCreateProjectFromPresale="closeModalInfoClientAndProject"
      :projectInfo="sellOrderPresale"
      :client="clientPresale"
      :onlyRead="true"
    >
    </modal-create-project-from-presale>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { formatDateMomentToHuman } from "@/helpers/common";
import ModalUpdateOrCreatePresale from "./components/ModalUpdateOrCreatePresale.vue";
import ModalLinkPresaleToProject from "./components/ModalLinkPresaleToProject.vue";
import roles from "@/mixins/roles";
import validateRestrictionUserDocuments from "@/mixins/documents/validateRestrictionUserDocuments";
import { authUsuarioComputed } from "@/state/helpers";
import {
  businessUnitFilterComputed,
  businessUnitFilterMethods,
} from "@/state/helpers";
import {
  COST_CENTER_MANAGMENT_CONTROL,
  NEW_COST_CENTER_MANAGMENT_CONTROL,
} from "@/constants/common";
import {
  LIST_STATUS_PRESALE,
  STATUS_PRESALE_REVIEW_PENDING,
  STATUS_PRESALE_APPROVED,
  STATUS_PRESALE_REVIEW_USER,
  STATUS_PRESALE_SIGNED,
  ACTIVE_BUSINESS_UNITS,
  BUSINESS_UNIT_RESIDENTIAL_CODE,
  PERMISSION_FOR_CECO,
} from "@/constants/presale";
import moment from "moment";
import ModalCreateProjectFromPresale from "./components/ModalCreateProjectFromPresale.vue";
import { getQueryParamsFromPresale } from "@/helpers/presale";
export default {
  mixins: [roles, validateRestrictionUserDocuments],
  components: {
    ModalUpdateOrCreatePresale,
    ModalLinkPresaleToProject,
    ModalCreateProjectFromPresale,
  },
  data() {
    return {
      BUSINESS_UNIT_RESIDENTIAL_CODE,
      LIST_STATUS_PRESALE,
      STATUS_PRESALE_REVIEW_PENDING,
      STATUS_PRESALE_APPROVED,
      STATUS_PRESALE_REVIEW_USER,
      STATUS_PRESALE_SIGNED,
      dialogCreatePresale: false,
      dialogLinkPresaleToProject: false,
      dialogInfoClientAndProject: false,
      currentPresale: null,
      sellOrderPresale: null,
      clientPresale: null,
      loading: false,
      loadingActions: false,
      debounce: null,
      debounceTime: 500,
      filters: {
        page: 1,
        items: 10,
        filter: "",
        name_filter: "",
        business_unit: "",
        approved_status: null,
      },
      tableHeaders: [
        {
          value: "code",
          text: "Código de Preventa",
          sortable: false,
          align: "center",
          width: "8%",
        },
        {
          value: "name",
          text: "Nombre del Proyecto",
          sortable: false,
          width: "25%",
        },
        {
          value: "business_unit",
          text: "Unidad de Negocio",
          sortable: false,
          align: "center",
          width: "10%",
        },
        {
          value: "approved_status",
          text: "Estatus",
          sortable: false,
          align: "center",
          width: "10%",
        },
        {
          value: "created_at",
          sortable: false,
          align: "center",
          text: "Fecha Creación",
          width: "10%",
        },
        {
          value: "actions",
          sortable: false,
          align: "center",
          text: "Acciones",
          width: "10%",
        },
      ],
    };
  },
  mounted() {
    this.filters.business_unit = this.businessUnitFilter;
    this.getPresalesData();
  },
  methods: {
    ...businessUnitFilterMethods,
    ...mapActions({
      getAllPresales: "presale/getAllPresales",
      deletePresaleService: "presale/deletePresale",
      getSellOrderFromPresale: "presale/getSellOrderFromPresale",
      updateStatusPresale: "presale/updateStatusPresale",
      getDocuments: "document/getDocuments",
    }),
    getColorPresale(approved_status) {
      switch (approved_status) {
        case STATUS_PRESALE_REVIEW_PENDING:
          return "primary";
        case STATUS_PRESALE_APPROVED:
          return "success";
        case STATUS_PRESALE_REVIEW_USER:
          return "warning";
        default:
          return "primary";
      }
    },
    async getPresalesData(page = 1) {
      clearTimeout(this.debounce);
      this.updateBusinessUnitFilter(this.filters.business_unit);
      let self = this;
      this.debounce = await setTimeout(async function() {
        self.loading = true;
        self.filters.page = page;
        await self.getAllPresales({
          page,
          approved_status: self.filters.approved_status
            ? self.filters.approved_status
            : undefined,
          business_unit_filter: self.showAllPresales
            ? self.filters.business_unit
              ? self.filters.business_unit
              : undefined
            : self.businessUnits.length
            ? self.businessUnits[0].code
            : undefined,
          general_filter: self.filters.filter ? self.filters.filter : undefined,
          name_filter: self.filters.name_filter
            ? self.filters.name_filter
            : undefined,
          items: self.filters.items,
        });
        self.loading = false;
      }, self.debounceTime);
    },
    async showPresaleDocuments(item) {
      let presaleParams = getQueryParamsFromPresale(item)
      let urlShowPresale =
        "/preventa/" +
        item.code +
        "/documentos?presale_code=" +
        presaleParams.presale_code +
        "&presale_name=" +
        presaleParams.presale_name +
        "&presale_type=" +
        presaleParams.presale_type +
        "&have_project=" +
        presaleParams.have_project;
      //Agregar parametro approved_status de forma condicional
      if (presaleParams.approved_status) {
        urlShowPresale += "&approved_status=" + presaleParams.approved_status;
      }
      this.$router.push(urlShowPresale);
    },
    formatDateToHuman(date) {
      return formatDateMomentToHuman(date);
    },
    openModalUpdateOrCreatePresale(presale) {
      if (!presale) {
        this.$refs.modalUpdateOrCreatePresale.setBusinessUnitDefault();
      }
      this.currentPresale = presale;
      this.dialogCreatePresale = true;
    },
    openModalLinkPresaleToProject(presale) {
      this.currentPresale = presale;
      this.dialogLinkPresaleToProject = true;
    },
    async openModalClientAndProjectInfo(presale) {
      this.$refs.modalCreateProjectFromPresale.resetForm();
      this.loadingActions = true;
      const resp = await this.getSellOrderFromPresale({
        pre_project_id: presale.id,
      });
      if (resp.data && resp.data.data.length) {
        await this.getDocuments({
          pre_project_code: presale.code,
        });
        this.loadingActions = false;
        this.sellOrderPresale = resp.data.data[0];
        this.clientPresale = resp.data.data[0].empresa_rut
          ? resp.data.data[0].empresa_rut
          : resp.data.data[0].client_rut;
        if (resp.data.data[0].empresa_rut) {
          this.$refs.modalCreateProjectFromPresale.setTypeClientCompany();
        }
        this.dialogInfoClientAndProject = true;
      } else {
        this.loadingActions = false;
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: "No se encontró información asociada a la preventa",
          position: "top-end",
          showConfirmButton: false,
          toast: true,
          timer: 5000,
          timerProgressBar: true,
        });
      }
    },
    closeModalCreateOrUpdatePresale() {
      this.currentPresale = null;
      this.dialogCreatePresale = false;
    },
    closeModalLinkPresaleToProject() {
      this.currentPresale = null;
      this.dialogLinkPresaleToProject = false;
    },
    closeModalInfoClientAndProject() {
      this.sellOrderPresale = null;
      this.clientPresale = null;
      this.dialogInfoClientAndProject = false;
    },
    deletePresale(presale) {
      this.$swal
        .fire({
          icon: "warning",
          title:
            "¿Estás seguro de eliminar el Proyecto de Preventa con código: " +
            "<b>" +
            presale.code +
            "</b>" +
            "?",
          text: "Esta acción no se puede deshacer",
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "red",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value) {
            this.loadingActions = true;
            const resp = await this.deletePresaleService({
              preventa_id: presale.id,
              user: this.user.email,
              comment: "Eliminado por " + this.user.email,
            });
            if (resp.status == 200) {
              this.$swal.fire({
                icon: "success",
                title: "Excelente",
                text:
                  "El Proyecto de Preventa con código: " +
                  presale.code +
                  " ha sido eliminado",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 7000,
                timerProgressBar: true,
              });
              this.getPresalesData();
            }
            if (!resp.status || resp.status === 400) {
              this.loadingActions = false;
              return this.$swal.fire({
                icon: "error",
                title: "Error",
                text: resp.data.detail,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 10000,
                timerProgressBar: true,
              });
            }
            this.loadingActions = false;
          }
        });
    },
    changePresaleStatus(presale, status) {
      let message =
        status == STATUS_PRESALE_APPROVED
          ? `Aprobar y Crear Proyecto en SAP`
          : status == STATUS_PRESALE_REVIEW_USER
          ? `Enviar a Revisión por Usuario`
          : `Enviar a Pendiente de Revisión`;
      this.$swal
        .fire({
          icon: STATUS_PRESALE_REVIEW_USER ? "warning" : "info",
          title:
            `¿Estás seguro de ${message} la Preventa con código: ` +
            "<b>" +
            presale.code +
            "</b>" +
            "?",
          text: "",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#4285F4",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value) {
            this.loadingActions = true;
            const resp = await this.updateStatusPresale({
              preventa_id: presale.id,
              user: this.user.email,
              status,
            });
            if (!resp || resp?.status == 500) {
              this.loadingActions = false;
              return this.$swal.fire({
                icon: "error",
                title: "Error",
                text:
                  "Ha ocurrido un error en el servidor, intentalo nuevamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 4000,
                timerProgressBar: true,
              });
            }
            if (resp?.status == 200) {
              this.$swal.fire({
                icon: "success",
                title: "Excelente",
                text: `El estatus de la Preventa ha sido actualizado correctamente a ${status}`,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 7000,
                timerProgressBar: true,
              });
              this.getPresalesData();
            }
            if (!resp.status || resp.status === 400) {
              this.loadingActions = false;
              return this.$swal.fire({
                icon: "error",
                title: "Error",
                text: resp.data.detail?.error
                  ? resp.data.detail.error.message
                  : resp.data.detail,
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 10000,
                timerProgressBar: true,
              });
            }
            this.loadingActions = false;
          }
        });
    },
    async downloadExcelReportPresale() {
      let self = this;
      this.loadingActions = true;
      const response = await this.getAllPresales({
        business_unit_filter: self.filters.business_unit
          ? self.filters.business_unit
          : undefined,
        general_filter: self.filters.filter ? self.filters.filter : undefined,
        name_filter: self.filters.name_filter
          ? self.filters.name_filter
          : undefined,
        export: true,
        not_update_list: true,
      });
      let fileURL = window.URL.createObjectURL(new Blob([response]));
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        `reporte_preventas_${moment().format("DD-MM-YYYY")}.xlsx`,
      );
      document.body.appendChild(fileLink);
      fileLink.click();
      this.loadingActions = false;
    },
    verifyCurrentUserPermissionToManageAutomationPresales(presale) {
      if (
        this.dataEmployees &&
        this.dataEmployees.employees[0] &&
        this.dataEmployees.employees[0].cost_center
      ) {
        const hasPermission = PERMISSION_FOR_CECO.some((permission) => {
          return (
            permission.business_unit_code === presale.business_unit.code &&
            permission.cecos.includes(
              this.dataEmployees.employees[0].cost_center.code,
            )
          );
        });

        return hasPermission;
      } else {
        return false;
      }
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...businessUnitFilterComputed,
    ...mapGetters({
      presales: "presale/presales",
      businessUnits: "common/businessUnits",
      businessUnitFilter: "businessUnitFilter/businessUnitFilter",
      dataEmployees: "maintainers/employeeInfoUser",
    }),
    showAllPresales() {
      return (
        this.currentUserIsSuperAdmin ||
        this.activeBusinessUnits.length > 1 ||
        this.verifyUserBelongsToCgestionCostCenter
      );
    },
    verifyUserBelongsToCgestionCostCenter() {
      return (
        this.dataEmployees.employees.length &&
        this.dataEmployees.employees.find(
          (employee) =>
            employee.cost_center.code == COST_CENTER_MANAGMENT_CONTROL ||
            employee.cost_center.code == NEW_COST_CENTER_MANAGMENT_CONTROL,
        )
      );
    },
    verifyUserBelongsToComCostCenter() {
      return (
        this.dataEmployees.employees.length &&
        this.dataEmployees.employees.find((employee) =>
          employee.cost_center.code == COST_CENTER_RESIDENTIAL_COM || employee.cost_center.code == COST_CENTER_RESIDENTIAL_COM_V2
        )
      );
    },
    wrappedTableHeaders() {
      return this.tableHeaders;
    },
    activeBusinessUnits() {
      return this.businessUnits.filter((item) =>
        ACTIVE_BUSINESS_UNITS.includes(item.name),
      );
    },
  },
  watch: {
    "filters.page"(newValue) {
      this.getPresalesData(newValue);
    },
  },
};
</script>

<style></style>